import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const BusinessRelationList = Loadable(
  lazy(() => import("./BusinessRelationList")),
);
const BusinessRelationForm = Loadable(
  lazy(() => import("./BusinessRelationForm")),
);

const businessRelationRoutes = [
  {
    path: "/BusinessRelation/BusinessRelationList",
    element: <BusinessRelationList />,
    permission: PERMISSIONS.BusinessRelations.Menu,
  },
  {
    path: "/BusinessRelation/BusinessRelationForm",
    element: <BusinessRelationForm />,
  },
  {
    path: "/BusinessRelation/BusinessRelationForm/:businessRelationId",
    element: <BusinessRelationForm />,
  },
];

export default businessRelationRoutes;
